import { ProfileTypes } from '@api/Users/User';
import adminRoutes from '@navigation/adminRoutes';
import collaboratorRoutes from '@navigation/collaboratorRoutes';
import distributionCenterRoutes from '@navigation/distributionCenterRoutes';
import branchAdminRoutes from '@navigation/branchAdminRoutes';
import { RoutesInterface } from '@navigation/authRoutes';
export const getRoutesByProfile = (profile?: ProfileTypes): RoutesInterface[] => {
    switch (profile) {
        case ProfileTypes.Admin:
            return adminRoutes;
        // Las del gerente + Dashboard, Usuarios, Mi sucursal y cupones (F6 del plan de Gastos).
        case ProfileTypes.BranchAdmin:
            return branchAdminRoutes;
        case ProfileTypes.Manager:
            return collaboratorRoutes;
        case ProfileTypes.Collaborator:
            return collaboratorRoutes;
        case ProfileTypes.DistributionCenter:
            return distributionCenterRoutes;
        default:
            // Least privilege: an unknown/undefined profile gets no routes
            // instead of falling back to the full admin menu.
            return [];
    }
};
